<template>
  <footer>
    <div class="footer-contact">
      <div class="container">
        <div>{{this.$t('lang_men_contact')}}</div>
        <div>{{this.$t('lang_footer_service')}}<i class="icon-mail"></i><i class="icon-27"></i>sales@rollingbet.com</div>
        <div>{{this.$t('lang_footer_support')}}<i class="icon-27"></i><i class="icon-mail"></i>info@rollingbet.com</div>
      </div>
    </div>
    <div class="footer-copyright">
      <div class="container">
        <span>Copyrights by Rolling Bet 2019. All Rights Reserved.</span>
        <i><img src="@img/logo.png" alt=""></i>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
    name: 'Footer'
}
</script>